<template>
  <el-dialog
    :title="staffId < 0 ? '新增员工信息' : '员工信息'"
    :visible="staffDialogType == 'info'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="initStaffInfo"
    width="50%"
  >
    <p class="info-title">基本信息</p>
    <div class="base-info">
      <el-form label-position="right" label-width="150px" :model="staffInfo">
        <el-form-item label="工号">
          <el-input v-model="staffInfo.user_name" v-if="staffId < 0"></el-input>
          <span v-else>{{ staffInfo.user_name }}</span>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-select
            v-model="staffInfo.company_id"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="staffInfo.real_name"></el-input>
        </el-form-item>
        <el-form-item label="英文名">
          <el-input v-model="staffInfo.foreign_name"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="staffInfo.gender" placeholder="请选择性别">
            <el-option
              v-for="(index, key) in GENDER_STATUS"
              :key="key"
              :label="index"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="staffInfo.id_num"></el-input>
        </el-form-item>
        <el-form-item label="电话号码">
          <el-input v-model="staffInfo.phone_num"></el-input>
        </el-form-item>
        <el-form-item label="在职状态">
          <el-select v-model="staffInfo.status" placeholder="请选择在职状态">
            <el-option
              v-for="(item, index) in STAFF_STATUS"
              :key="index"
              :label="item"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="info-footer">
        <el-button type="success" @click="saveStaffInfo" :loading="isLoading"
          >保 存</el-button
        >
      </div>
    </div>
    <template v-if="staffId > 0 && expandInfo.length > 0">
      <p class="info-title">拓展信息</p>
      <div class="base-info">
        <el-form label-position="right" label-width="150px" :model="staffInfo">
          <el-form-item
            :label="item.key_desc"
            v-for="(item, index) in expandInfo"
            :key="item.id"
          >
            <span class="info-edit-input">
              <el-input v-if="item.isEdit" v-model="item.editInfo"></el-input>
              <span v-else>{{ item.info }}</span>
            </span>
            <el-button
              :type="item.isEdit ? 'danger' : 'primary'"
              :icon="item.isEdit ? 'el-icon-close' : 'el-icon-edit'"
              @click="changeExpandIsEdit(index)"
              circle
              plain
            ></el-button>
            <el-button
              type="success"
              icon="el-icon-check"
              v-if="item.isEdit"
              @click="updateExpandInfo(item, index)"
              circle
              plain
            ></el-button>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  managerStaffDetails,
  managerUpdateStaffDetails,
  managerAddStaffDetails,
  managerUpdateExpandInfo,
} from '@/api/manager'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      staffInfo: {},
      expandInfo: [],
      isLoading: false,
      isChange: false,
    }
  },
  props: ['staffDialogType', 'staffId'],
  computed: {
    ...mapGetters(['companyList']),
  },
  methods: {
    closeDialog() {
      this.staffInfo = {}
      if (this.isChange) {
        this.$emit('updateStaffList')
      }
      this.$emit('update:staffDialogType', '')
    },
    initStaffInfo() {
      this.isChange = false
      if (this.staffId < 0) {
        this.staffInfo = {
          user_name: '',
          real_name: '',
          foreign_name: '',
          phone_num: '',
          gender: '1',
          id_num: '',
          company_id: '',
          status: '1',
        }
      } else {
        this.getSatffInfo()
      }
    },
    async getSatffInfo() {
      let { code, result } = await managerStaffDetails({ id: this.staffId })
      if (code == this.CONFIG.CODE_SUCCESS) {
        result.base.status = '' + result.base.status
        result.base.gender = '' + result.base.gender
        this.staffInfo = result.base
        this.expandInfo = result.expand.map((item) => {
          item.isEdit = false
          item.editInfo = item.info
          return item
        })
      }
    },
    saveStaffInfo() {
      if (this.staffId < 0) {
        this.addStaffInfo()
      } else {
        this.updateStaffInfo()
      }
    },
    async addStaffInfo() {
      let postData = { ...this.staffInfo }
      this.isLoading = true
      let { code, msg } = await managerAddStaffDetails(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.$message({
          type: 'success',
          message: msg,
        })
        this.isChange = true
        this.closeDialog()
      }
    },
    async updateStaffInfo() {
      let postData = { ...this.staffInfo }
      postData.id = this.staffId
      this.isLoading = true
      let { code, msg } = await managerUpdateStaffDetails(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.isChange = true
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
    changeExpandIsEdit(_index) {
      this.expandInfo[_index].isEdit = !this.expandInfo[_index].isEdit
    },
    async updateExpandInfo(_item, _index) {
      let postData = {
        staff_id: this.staffId,
        key_id: _item.id,
        info: _item.editInfo,
      }
      let { code, msg } = await managerUpdateExpandInfo(postData)
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.expandInfo[_index].info = postData.info
        this.expandInfo[_index].isEdit = false
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.info-title {
  font-size: 16px;
  line-height: 40px;
}
.base-info {
  background: #f6f6f6;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
}
.info-footer {
  text-align: right;
}
.info-edit-input {
  display: inline-block;
  width: 400px;
  margin-right: 15px;
}
</style>
